import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { UserService } from "../../../Shared/Services/user.service";
import { default as GridColumnsJSON } from './processed-transactions-exceptions-columns.json';
import { APIURL } from "../../../Shared/Constant/API_Urls";
import { GridService } from "../../../Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { CommonModule, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { QuickviewSidebarComponent } from 'app/Shared/Component/quickview-sidebar/quickview-sidebar.component';

@Component({
  selector: 'app-processed-transactions-exceptions',
  imports: [FilterPanelComponent, QuickSearchComponent,
    CommonModule, MatProgressSpinner, ToastModule, ExportToCSVSComponent, QuickviewSidebarComponent,
    TableModule, NgClass, ButtonModule, DialogModule, FormsModule, MatTooltipModule
  ],
  templateUrl: './processed-transactions-exceptions.html',
  styleUrls: ['./processed-transactions-exceptions.scss']
})
export class ProcessedTransactionsExceptionComponent implements OnInit, OnChanges, OnDestroy {
  quickFilterArray: any = GridColumnsJSON["Quick-Search-Fields"];
  GridColumns: any = GridColumnsJSON["Grid-Columns"];
  exportGridColumns: any = [];
  cols: any = [];
  isQuickViewOpenClose: boolean = false;
  Dataset: any[] = [];
  LastExecutionODRDate!: any[];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  PageName = "Processed_Transactiions_Exceptions";
  Limit: any = { 'Start': '', 'End': '' };
  selectedRow: any = [];
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  pageNumber: any = 1;
  priviousStartLimit: any;
  endLimit!: number;
  subscription!: Subscription;
  columnJson: any = [];
  filterCols: any = [];

  constructor(
    private userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,) {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.defaultFilter();
    this.loadInitialData();
  }

  ngOnInit(): void {
    this.exportGridColumns = this.GridColumns.filter((Obj: { excludeFromExport: any; }) => !Obj.excludeFromExport);
    this.rowcount = this.gridService.getGridRowsCount();
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.Dataset = [];
    this.defaultFilter();
    this.loadInitialData();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.getColumns();
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  onView(index: any, row: any) {
    this.isQuickViewOpenClose = false;
    this.selectedRow = [];
    this.selectedRow.push(row);
    this.isQuickViewOpenClose = true;

  }

  onViewOrderID(rowData:any){
    this.emitterService.isODROrderViewerOpenCloseEvent.emit(
        {
          display: true,
          rowData: rowData,
          pageName: 'ODR'
        });
  }

  updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }


  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  QuickViewCloseEvent(event: any) {
    this.selectedRow = [];
    this.isQuickViewOpenClose = false;
  }


  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  defaultFilter() {
    let date = this.userService.ODR_ProcessedTransactionReportDate;
    this.LastExecutionODRDate = [date,date];
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionODRDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { "isdefault": "true", "label": "Venue Name", "columnname": "VenueName", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Order ID", "columnname": "OrderID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Exception Status", "columnname": "exceptionStatus", "filterby": "IS", "values": "OPEN", "time": "", "datatype": "String", "disabled": true, },
    ];
    this.Limit.Start = 0;
  }

  async loadInitialData() {
    if(!this.userService.ODR_ProcessedTransactionReportDate) {
      await this.userService.getODRLastReportedDate();
    }
    
    let date = this.userService.ODR_ProcessedTransactionReportDate ?? new Date();
    this.LastExecutionODRDate[0] = date;
    this.LastExecutionODRDate[1] = date;
    this.getData();
  }


  getData() {
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.ODR_Processed_Transactiions_Exceptions, this.DefaultFilterArray, this.Limit, "Processed_Transactiions")
      .subscribe({
        next: (Element: any) => {
          this.isLoadingResults = false;
          let dataset: any = Element;
          this.Dataset = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }, error: (err: HttpErrorResponse) => {
          this.Dataset = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingResults = false;
        }
      });

  }




  exportToCSV(event: { isExportMaxRows: any; gridColumn: any; }) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    }
    this.gridService.getData(
      APIURL.ODR_Processed_Transactiions_Exceptions,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      this.PageName
    ).subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        let data = dataset.Data;

        if (data.length > 0) {
          data.forEach((col: { originalJSON: any; }) => {
            delete col.originalJSON;
          });
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'RSMS_' + this.PageName + '_' + this.userService.getyyyyMMddDateFormate(new Date()),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
            filename: this.userService.getActiveMPID() + '_RSMS_' + this.PageName + '_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(data, event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob, options.filename);
          this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }


  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}